import { useState, useRef, useEffect } from 'react';

export default function WaveSlider({ value, onChange, width = 300, height = 60, scale = 1, label, min = 0, max = 2 }){
  const valueToSliderValue = (val) => ((val - min) / (max - min)) * 100;
  const sliderValueToValue = (sliderVal) => (sliderVal / 100) * (max - min) + min;

  const [colorIndex, setColorIndex] = useState(0);
  const [isDragging, setIsDragging] = useState(false);
  const sliderRef = useRef(null);
  
  const bg = '#1b1b1b';
  const figma = ['#ffffff','#AF50FF', '#00BEFF', '#FF685F', '#F7C839','#FF3E0D', '#FD9540', '#F7C839', '#00D37E'];
  const margin = 20;
  
  // Calculate wave path
  const generateWavePath = () => {
    const trackWidth = width - margin * 2;
    const amplitude = valueToSliderValue(value) / 100 * 24; // Convert value to 0-100 range first
    const frequency = 360 * (9 / 2);
    const centerY = height / 2;
    
    let path = '';
    for (let x = 0; x <= trackWidth; x += 2) {
      const y = centerY - Math.sin((frequency * x / trackWidth) * Math.PI / 180) * amplitude;
      if (x === 0) {
        path += `M ${margin + x} ${y}`;
      } else {
        path += ` L ${margin + x} ${y}`;
      }
    }
    return path;
  };
  
  const handleMouseDown = (e) => {
    setIsDragging(true);
    handleMouseMove(e);
  };
  
  const handleMouseMove = (e) => {
    if (!isDragging && e.type === 'mousemove') return;
    
    const slider = sliderRef.current;
    if (!slider) return;
    
    const rect = slider.getBoundingClientRect();
    // The bounding rect is already scaled, so we need to map from scaled coordinates
    // back to the original coordinate system
    const scaledX = e.clientX - rect.left;
    const originalX = (scaledX / rect.width) * width; // Map from scaled width back to original width
    
    const trackWidth = width - margin * 2;
    const newValue = Math.max(0, Math.min(100, ((originalX - margin) / trackWidth) * 100));
    
    if (onChange) {
      onChange(sliderValueToValue(newValue));
    }
  };

  useEffect(() => {
    if (isDragging) {
      const handleGlobalMouseMove = (e) => handleMouseMove(e);
      const handleGlobalMouseUp = () => setIsDragging(false);
      
      document.addEventListener('mousemove', handleGlobalMouseMove);
      document.addEventListener('mouseup', handleGlobalMouseUp);
      
      return () => {
        document.removeEventListener('mousemove', handleGlobalMouseMove);
        document.removeEventListener('mouseup', handleGlobalMouseUp);
      };
    }
  }, [isDragging]);
  
// Calculate positions
const trackWidth = width - margin * 2;
const sliderValue = valueToSliderValue(value); // Convert value to 0-100 range
const constrainedX = Math.max(margin, Math.min(width - margin, (sliderValue / 100) * trackWidth + margin));
  const centerY = height / 2;
  
  // Calculate scrim position
  const scrimWidth = 100;
  const scrimX = Math.min(constrainedX + 15, width - scrimWidth);
  
  return (
    <div style = { { display : "flex", flexDirection : "row", alignItems : "center", gap : "6px" } }>
        {/* LABEL */}
        <p style = { { color : "white", fontFamily : "var(--font-IBM)", textTransform : "uppercase", fontSize : "var(--font-size-teeny)" } }>{ label } { value.toFixed(2) }</p>
        
        {/* SLIDER */}
        <div 
        style={{ 
            cursor: isDragging ? 'grabbing' : 'grab',
            borderRadius: '8px',
            overflow: 'hidden',
            transform: `scale(${scale})`, transformOrigin: 'left center',
        }}
        >
        <svg
            ref={sliderRef}
            width={width}
            height={height}
            onMouseDown={handleMouseDown}
            onMouseMove={handleMouseMove}
            onMouseUp={() => setIsDragging(false)}
            style={{ display: 'block' }}
        >
            {/* Background */}
            {/* <rect width={width} height={height} fill={bg} /> */}
            
            {/* Track (horizontal line) */}
            <rect
            x={margin}
            y={centerY - 10}
            width={trackWidth}
            height={20}
            rx={10}
            fill="rgba(255, 255, 255, 0.16)"
            />
            
            {/* Wave path */}
            <path
            d={generateWavePath()}
            //   stroke={figma[colorIndex]}
            strokeWidth="10"
            strokeLinecap="round"
            strokeLinejoin="round"
            //   fill="rgba(255, 255, 255, 0.40)"
            stroke = "rgba(255, 255, 255, 0.56)"
                fill = "none"
            />
            
            {/* Slider handle */}
            <rect
            x={constrainedX - 5}
            y={centerY - 37.5}
            width={10}
            height={75}
            rx={10}
            ry={10}
            fill="#ffffff"
            />
        </svg>
        </div>
    </div>
  );
};